

import { createSlice } from "@reduxjs/toolkit";
import { getGlobalDataApi } from "../configureStore";
export const globalSlice = createSlice({
    name: 'global',
    loading:false,
    initialState: {
        showMore: {
            desktop: 17,
            mobile: 5
        },
        url: null,
        settings: {},
        localization: {}
    },
    reducers: {
        setLang: (state, action) => {
            state.url = action.payload.url;
            state.localization = state.settings.langs[action.payload.locale.toLowerCase()]
        },
        setLoader: (state, action) => { 
            state.loading = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addMatcher(getGlobalDataApi.endpoints.fetchGlobalData.matchFulfilled, (state, action) => {
            state.settings = action.payload;
        })
    }

}
)
